module.exports = __webpack_public_path__ + "img/bg-audio-1.3e45b6f9.png";